/**
 *
 * @returns {Boolean}
 */
const isLSAvailable = () =>
  typeof window !== "undefined" &&
  !!window.document &&
  !!window.document.createElement &&
  "localStorage" in window;
/**
 *
 * @param {String} stateKey
 * @param {String} dataKey
 * @returns {Object}
 */

export const loadLSStateKey = (stateKey, dataKey) => {
  if (isLSAvailable()) {
    const state = localStorage.getItem(stateKey);
    if (typeof state === "string" && state !== "") {
      try {
        const stateObj = JSON.parse(state);
        return stateObj[dataKey];
      } catch (e) {
        return null;
      }
    }
  }
  return null;
};

/**
 *
 * @param {String} stateKey
 * @param {String} dataKey
 * @param {Object} newValue
 */
export const setLSStateKey = (stateKey, dataKey, newValue) => {
  if (isLSAvailable()) {
    let newStateObj = {
      [dataKey]: newValue,
    };
    const oldState = localStorage.getItem(stateKey);
    if (typeof oldState === "string" && oldState !== "") {
      try {
        const oldStateObj = JSON.parse(oldState);
        newStateObj = {
          ...oldStateObj,
          ...newStateObj,
        };
      } catch (e) {
        console.warn(e);
      }
    }
    localStorage.setItem(stateKey, JSON.stringify(newStateObj));
  }
};
